import React, { useEffect, useMemo, useState } from 'react';
import { buildUploadImageCandidates } from '../utils/cleroFotos';

const FALLBACK_SLIDE = `${process.env.PUBLIC_URL || ''}/images/slider01.png`;

/**
 * Imagen del carrusel con varias URLs de respaldo si /uploads falla en el servidor.
 */
const HeroSlideImage = ({ image, imageCandidates, alt, isActive }) => {
  const candidates = useMemo(() => {
    const fromProp = Array.isArray(imageCandidates) ? imageCandidates.filter(Boolean) : [];
    if (fromProp.length > 0) return [...new Set(fromProp)];
    if (image) {
      const built = buildUploadImageCandidates(image);
      if (built.length > 0) return built;
      return [image];
    }
    return [FALLBACK_SLIDE];
  }, [image, imageCandidates]);

  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setAttempt(0);
  }, [image, imageCandidates]);

  const hasPhoto =
    Boolean(image) ||
    (Array.isArray(imageCandidates) && imageCandidates.some(Boolean));
  const exhausted = hasPhoto && attempt >= candidates.length;
  const useFallback = !hasPhoto || exhausted;
  const src = useFallback ? FALLBACK_SLIDE : candidates[attempt];

  return (
    <img
      className={`slide-img${useFallback ? ' slide-img-fallback' : ''}`}
      src={src}
      alt={alt || ''}
      decoding="async"
      fetchPriority={isActive ? 'high' : 'low'}
      onError={() => {
        if (!hasPhoto || useFallback) return;
        setAttempt((a) => a + 1);
      }}
    />
  );
};

export default HeroSlideImage;
export { FALLBACK_SLIDE };
